import './assets/EmptyState.css';

/**
 * Placeholder shown in place of a view that has no data.
 *
 * headingLevel lets a caller fit the title into the surrounding heading order;
 * the default h1 keeps every caller that replaces a whole page body unchanged.
 * A caller that already shows the title on screen omits it so the placeholder
 * does not repeat the heading it sits under.
 */
const EmptyState = ({ title, message, headingLevel: Heading = 'h1' }) => {
  return (
    <div className="user-select-none d-flex flex-column h-100 overflow-y-scroll gap-2 p-3 border rounded-3 empty-container">
      {title && <Heading className="m-0 fw-bold empty-title">{title}</Heading>}
      <p className="m-0 empty-text">{message}</p>
    </div>
  );
};

export default EmptyState;
